<template>
    <!-- eslint-disable vue/no-v-html -->
    <span
        :class="iconClasses"
        :style="iconStyles"
        v-html="iconContent"
    />
</template>

<style module>
    .icon {
        display: inline-flex;
        vertical-align: middle;
        width: var(--icon-size, 1em);
        height: var(--icon-size, 1em);
        justify-content: center;
        align-items: center;
    }

    .icon > svg {
        width: 100%;
        height: 100%;
    }

    .icon > svg * {
        fill: var(--icon-color, currentColor);
    }

    @keyframes spin-frames {
        to { transform: rotate(360deg) }
    }

    .spin > svg {
        animation: spin-frames var(--icon-spin-speed, .6s) linear infinite;
    }
</style>

<script>
import Vue from 'vue'
const iconStore = Vue.observable({ data: {} })
const fetchPromiseMap = new Map()

export const register = (...args) => {
    args.forEach(icons => {
        for (const name in icons) {
            Vue.set(iconStore.data, name, icons[name])
        }
    })
}

function fetchIcon (url) {
    let promise = fetchPromiseMap.get(url)
    if (!promise) {
        promise = fetch(url)
            .then(res => {
                if (!res.ok) {
                    return null
                }
                return res.text()
            })
            .catch(_ => null)
        fetchPromiseMap.set(url, promise)
    }
    return promise
}

export default {
    inheritAttrs: false,

    props: {
        name: {
            type: String,
            required: true
        },

        color: {
            type: String,
            default: undefined
        },

        size: {
            type: String,
            default: undefined
        },

        spin: {
            type: Boolean,
            default: false
        },

        spinSpeed: {
            type: String,
            default: undefined
        }
    },

    data () {
        return {
            iconContent: null
        }
    },

    computed: {
        iconClasses () {
            return {
                [this.$style.icon]: true,
                [this.$style.spin]: this.spin
            }
        },

        iconStyles () {
            return {
                '--icon-color': this.color,
                '--icon-size': this.size,
                '--icon-spin-speed': this.spinSpeed
            }
        },

        iconUrl () {
            return iconStore.data[this.name] || null
        }
    },

    watch: {
        iconUrl: {
            handler () {
                this.handleIconUrlChange()
            },
            immediate: true
        }
    },

    methods: {
        handleIconUrlChange () {
            const fetchIconPromise = this.fetchIconPromise = fetchIcon(this.iconUrl)
                .then(iconContent => {
                    if (this.fetchIconPromise === fetchIconPromise) {
                        this.iconContent = iconContent
                    }
                })
        }
    }
}
</script>
